// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"_f2d1af","sectionTitleWrapper":"_b19550","screenshots":"_424cca"};